"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ForgotPasswordOtp;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _ForgotPasswordOtpComponent = _interopRequireDefault(require("../components/ForgotPasswordOtpComponent"));
var _reactRedux = require("react-redux");
var _strings = require("../common_features/utility/strings");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _index = _interopRequireDefault(require("../common_features/assets/index"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _helper = require("../common_features/utility/helper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ForgotPasswordOtp(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    email,
    challengeName
  } = userInfo;
  const [otpValue, setOtpValue] = (0, _react.useState)('');
  const [openErrorModal, setopenErrorModal] = (0, _react.useState)(false);
  const [newPassword, setPassword] = (0, _react.useState)(false);
  const [hasMinLength, setHasMinLength] = (0, _react.useState)(false);
  const [hasOneUpperLowerCase, sethasOneUpperLowerCase] = (0, _react.useState)(false);
  const [hasOneNumber, setHasOneNumber] = (0, _react.useState)(false);
  const [hasSpecialChar, setHasSpecialChar] = (0, _react.useState)(false);
  const [isNewPasswordTouch, setIsNewPasswordTouch] = (0, _react.useState)(false);
  const [confirmNewPassword, setConfirmPassword] = (0, _react.useState)(null);
  const [isConfirmPasswordTouch, setIsConfirmPasswordTouch] = (0, _react.useState)(false);
  const [displayPasswordChangeModal, setDisplayPasswordChangeModal] = (0, _react.useState)(false);
  const [resendCodeClick, setResendCodeClicked] = (0, _react.useState)(true);
  const [invalidOtp, setInvalidOtp] = (0, _react.useState)(false);
  function validatePassword(e, handler) {
    const value = e.target.value;
    setHasMinLength(value.length > 7);
    sethasOneUpperLowerCase(/[a-z]/.test(value) && /[A-Z]/.test(value));
    setHasOneNumber(/\d/.test(value));
    setHasSpecialChar(_strings.VALIDATION_REGX.specialCharacter.test(value));
    (0, _helper.onChangeHandler)(e, handler);
  }
  function onOtpChange(val) {
    setOtpValue(val);
  }
  const handleNewPasswordBlur = () => {
    setIsNewPasswordTouch(true);
  };
  const handleConfirmPasswordChange = (e, state) => {
    setIsConfirmPasswordTouch(true);
    (0, _helper.onChangeHandler)(e, state);
  };
  function checkDisabled() {
    return otpValue.length == 6 && newPassword && confirmNewPassword && newPassword === confirmNewPassword || false;
  }
  function resendDisabled() {
    return resendCodeClick || false;
  }
  function onClickResetButton() {
    dispatch((0, _loginReducer.loginUserInfo)({
      email,
      challengeName,
      code: otpValue
    }));
    setIsLoading(true);
    _awsAmplify.Auth.forgotPasswordSubmit(email, otpValue, newPassword).then(data => {
      setIsLoading(false);
      setDisplayPasswordChangeModal(true);
    }).catch(err => {
      console.log("error-->", err);
      setIsLoading(false);
      if (err.message === "Invalid verification code provided, please try again.") {
        setInvalidOtp(true);
      } else if (err.message === "Attempt limit exceeded, please try after some time.") {
        setopenErrorModal(true);
      }
    });
  }
  const onClickResendCode = () => {
    setResendCodeClicked(false);
    if (email) {
      setIsLoading(true);
      _awsAmplify.Auth.forgotPassword(email).then(data => {
        setIsLoading(false);
        setOtpValue('');
        setInvalidOtp(false);
      }).catch(err => {
        setIsLoading(false);
        if (err.message === "Attempt limit exceeded, please try after some time.") {
          setopenErrorModal(true);
        }
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (!(email && challengeName == _strings.CHALLENGE_NAME.FORGOT_PASSWORD)) {
      navigate("/ForgotPassword");
    }
  });
  const onClickSuccessPopup = () => {
    navigate(_RoutePath.default.login.path);
  };
  const onOkPress = () => {
    navigate(_RoutePath.default.login.path);
  };
  const handleBack = () => {
    navigate(-1);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ForgotPasswordOtpComponent.default, {
    headerText: 'Sign In',
    handleBack: handleBack,
    variant: "warning-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalDetailTextFail: "You have exceeded your attempt. Try after sometime.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Ok",
    positiveAction: onOkPress,
    resetButtonText: "Submit",
    forgotPasswordHeaderText: "Check Your Email",
    forgotPasswordDetailText: "We've sent you an email with a 6-digit code. Please check your email and enter the code below.",
    resendCodeButtonText: "Re-Send Code",
    headerPentairLogo: _index.default.pentairLogo.default,
    otpValue: otpValue,
    onChnageOtp: onOtpChange,
    otpCount: 6,
    onClickReset: onClickResetButton,
    isDisabled: checkDisabled(),
    onClickResendCode: onClickResendCode,
    isLoading: isLoading,
    passwordText: "New Password",
    newPasswordPlaceholder: "Enter new password",
    validationText1: "At least 8 characters",
    validationText2: "1 uppercase and 1 lowercase letter",
    validationText3: "1 number",
    validationText4: "1 special character",
    confirmPassword: "Confirm New Password",
    confirmPasswordPlaceholder: "Confirm new password",
    newpassword: newPassword,
    onChangeNewPassword: e => {
      validatePassword(e, setPassword);
    },
    hasMinLength: (0, _helper.getPasswordConditionCheckColor)(hasMinLength),
    hasOneNumber: (0, _helper.getPasswordConditionCheckColor)(hasOneNumber),
    hasOneUpperLowerCase: (0, _helper.getPasswordConditionCheckColor)(hasOneUpperLowerCase),
    hasSpecialChar: (0, _helper.getPasswordConditionCheckColor)(hasSpecialChar),
    errorMessage: !(hasMinLength && hasOneNumber && hasOneUpperLowerCase && hasSpecialChar),
    isNewPasswordTouch: isNewPasswordTouch,
    handleNewPasswordBlur: handleNewPasswordBlur,
    conFirmErrorMessage: confirmNewPassword !== newPassword && isConfirmPasswordTouch,
    passwordMatched: confirmNewPassword === newPassword,
    confirmNewPassword: confirmNewPassword,
    onChangeConfirmNewPassword: e => {
      handleConfirmPasswordChange(e, setConfirmPassword);
    },
    isSuccessModal: true,
    modalDetailText: "You have changed your password successfully!",
    continueButtonText: "Continue",
    displayPasswordChangeModal: displayPasswordChangeModal,
    setDisplayPasswordChangeModal: onClickSuccessPopup,
    resendCodePressed: resendCodeClick,
    resendDisabled: resendDisabled(),
    onComplete: () => setResendCodeClicked(true),
    invalidOtp: invalidOtp
  }));
}